import { View } from './view'

export const StepsWithTitle = View
